import React from 'react';
import { Select, Button } from '@v2/components';
import { InstanceFiltersProps } from './types';
import { styles } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';

const InstanceFilters: React.FC<InstanceFiltersProps> = ({
  pimsOptions,
  pimsFilter,
  onPimsFilterChange,
  activeFilters,
  onAddFilter,
  onEditFilter,
  onRemoveFilter,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.pimsSelect}>
        <Select
          id="pims-filter"
          options={pimsOptions}
          value={pimsFilter}
          onChange={e => onPimsFilterChange(e.target.value)}
          aria-label="Filter by PIMS"
        />
      </div>
      <Button variant="ghost-success" size="sm" onClick={onAddFilter}>
        <FontAwesomeIcon icon={faPlus} /> Add Filter
      </Button>
      {activeFilters.map((filter, index) => (
        <span key={index} className={styles.filterChip}>
          <span className={styles.filterLabel} onClick={() => onEditFilter(filter, index)}>
            {filter.filterType === 'instance'
              ? `Instance IDs (${filter.filterData.length})`
              : `PIMS: ${filter.filterData.join(', ')}`}
          </span>
          <span className={styles.filterRemove} onClick={() => onRemoveFilter(index)}>
            <FontAwesomeIcon icon={faTimes} />
          </span>
        </span>
      ))}
      {activeFilters.length > 1 && (
        <span className={styles.filtersNote}>*Multiple filters act as AND filters</span>
      )}
    </div>
  );
};

export default InstanceFilters;
export type { InstanceFiltersProps, InstanceFilter } from './types';
